import "babel-polyfill";
import Vue from "vue";
import VueMeta from "vue-meta";
import router from "./router";
import App from "./App.vue";
import VueCarousel from "vue-carousel";
import listNumber from "@/components/common/listNumber.vue";
import axios from "axios";
import VueMoment from "vue-moment";
import "@/assets/define.scss";
import VueAnalytics from "vue-analytics";
import Zendesk from '@dansmaculotte/vue-zendesk'


// Vue.use(VS2)
Vue.config.productionTip = false;
Vue.prototype.$Axios = axios;
Vue.use(VueMoment);
Vue.use(VueMeta);
Vue.use(VueCarousel);
Vue.component("list-number", listNumber);
Vue.use(Zendesk, {
  key: 'eba9c67f-cfda-42ce-853e-6ded80263557',
  disabled: false,
  settings: {
    webWidget: {
      color: {
        theme: '#78a300'
      }
    }
  }
})
// In a vue component
new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");

Vue.use(VueAnalytics, {
  id: "UA-208305121-1", // 콘솔에서 본인의 키를 확인하세요!
  router, // 원활한 트래킹을 위해 router를 꼭 바인드 해 주어야 합니다!
});
